import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import "rxjs/add/observable/zip";

@Injectable()
export class PollService {
  constructor(private db: AngularFireDatabase) {}

  create(poll): any {
    return this.db.list(`/polls/${poll.communityId}`)
    .push(poll).then(result => this.db.list(`/polls/${poll.communityId}`)
    .update(result.key, {id: result.key}));
  }

  getPolls(communityId): Observable<Array<{}>> {
    return this.db
    .list(`/polls/${communityId}`).valueChanges();
  }

  delete(poll): any {
    return this.db.list(`/polls/${poll.communityId}/${poll.id}`).remove();
  }

  getPollById(communityId, pollId): Observable<any> {
    return this.db.object(`/polls/${communityId}/${pollId}`).valueChanges();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/poll/poll.service.ts